// Email Service for Staff Management System (Frontend)
// This file handles the browser-specific email functionality.

import { generateEmailContent } from './emailGenerator.js';
import { EMAIL_RECIPIENT } from './config.js';
import logger from './logger.js';

// The main function that prepares and copies the content for the browser
export const sendEmail = async (type, employees, onNotify) => {
    const emailContent = generateEmailContent(type, employees);

    if (!emailContent) {
        const messages = {
            expired: "No expired residencies found",
            urgent: "No urgent cases found",
            both: "All residencies are valid"
        };
        if (onNotify) onNotify(messages[type] || "No data to send", 'info');
        return;
    }

    // --- 1. Copy full HTML report to clipboard ---
    try {
        // Use DOMParser for safer HTML parsing
        const parser = new DOMParser();
        const doc = parser.parseFromString(emailContent.body, 'text/html');
        const textContent = doc.body ? doc.body.textContent || doc.body.innerText : '';

        await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([emailContent.body], { type: 'text/html' }),
                'text/plain': new Blob([textContent], { type: 'text/plain' })
            })
        ]);

        // Show success message
        if (onNotify) {
            onNotify('Report copied to clipboard! Opening email client...', 'success');
        }

        // --- 2. Open mailto link (with empty body) ---
        const recipient = EMAIL_RECIPIENT;
        const subject = encodeURIComponent(emailContent.subject);
        const mailtoLink = `mailto:${recipient}?subject=${subject}`;

        // Small delay to ensure notification is shown
        setTimeout(() => {
            window.location.href = mailtoLink;
        }, 500);

    } catch (err) {
        logger.error('Failed to copy to clipboard:', err);
        if (onNotify) {
            onNotify('Failed to copy to clipboard! Please check browser permissions.', 'error');
        }
    }
};
